import script from "./FormVocePreventivoModale.vue?vue&type=script&setup=true&lang=js"
export * from "./FormVocePreventivoModale.vue?vue&type=script&setup=true&lang=js"

import "./FormVocePreventivoModale.vue?vue&type=style&index=0&id=796d2108&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-796d2108"]])

export default __exports__